import { createRandomString } from '@pcg/text-kit';

export class InvalidTokenException extends Error {
  message = 'InvalidTokenException';
}

export interface JsonWebToken {
  uid: string;
  exp: string;
}

export const generateRequestId = () => {
  return `hcreq:${createRandomString(11)}`;
};

/**
 * The API's cookie names under one prefix: `omb_` in production and every
 * workspace; another environment whose hosts also receive production's
 * cookies sets its own (`COOKIE_NAME_PREFIX` on the API, the matching
 * `VITE_OMB_COOKIE_NAME_PREFIX` on the frontend), or it would read
 * production's token instead of its own.
 */
export const cookieNames = (prefix = 'omb_') => ({
  session: `${prefix}session`,
  subscriptionToken: `${prefix}subscription_token`,
});

/**
 * Read a cookie value by name
 */
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  return match?.[2] ? decodeURIComponent(match[2]) : null;
};

/**
 * Get subscription token from cookie (for WebSocket connections)
 * This cookie is NOT httpOnly so JS can access it
 */
export const getSubscriptionTokenFromCookie = (prefix?: string): string | null => {
  return getCookie(cookieNames(prefix).subscriptionToken);
};

/**
 * Logout by calling the API to clear HTTP-only cookies
 */
export const logoutWithCookies = async (logoutUrl: string): Promise<void> => {
  await fetch(logoutUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-request-id': generateRequestId(),
    },
    credentials: 'include',
  });
};
